
// export const SidebarData = [


// {
//     tittle: 'MAIN',
//     showAsTab: false,
//     separateRoute: false,
//     menu: [
//       {
//         menuValue: 'Dashboard',
//         hasSubRoute: false,
//         showSubRoute: false,
//         route: "/employee-dashboard",
//         icon: "la la-dashcube",
//       },
//       {
//         menuValue: 'Employee Statstics',
//         hasSubRoute: false,
//         showSubRoute: false,
//         route: "/employee-statistics",
//         icon: "la la-chart-bar",
//       },
//       {
//         menuValue: 'Employees',
//         hasSubRoute: false,
//         showSubRoute: false,
//         route: "/employees",
//         icon: "la la-user",
//       },
//       {
//         menuValue: 'Holidays',
//         hasSubRoute: false,
//         showSubRoute: false,
//         route: "/holidays",
//         icon: "la la-calendar-o",
//       },
//       {
//         menuValue: 'Leaves',
//         hasSubRoute: true,
//         showSubRoute: false,
//         // route: "/leaves-employee",
//         icon: "la la-calendar-check-o",
//         subMenus: [
//           {
//             menuValue: 'Leave List',
//             route: "/leaves-employee",
//           },
//           {
//             menuValue: 'Leave View',
//             route: "/leave-calendar",
//           },
//           {
//             menuValue: 'Leave Planner',
//             route: "/leave-planner",
//           },
//         ]
//       },
//       {
//         menuValue: 'Company Directory',
//         hasSubRoute: false,
//         showSubRoute: false,
//         route: "/company-directory",
//         icon: "la la-user-shield",
//       },
//       // {
//       //   menuValue: 'Dashboard',
//       //   hasSubRoute: true,
//       //   showSubRoute: false,
//       //   route: "#",
//       //   icon: "la la-dashcube",
//       //   subMenus: [
//       //     {
//       //       menuValue: 'Admin Dashboard',
//       //       route: "/admin-dashboard",
//       //     },
//       //     {
//       //       menuValue: 'Employee Dashboard',
//       //       route: "/employee-dashboard",
//       //     },
//       //     {
//       //       menuValue: 'Deals Dashboard',
//       //       route: "/deals-dashboard",
//       //     },
//       //     {
//       //       menuValue: 'Leads Dashboard',
//       //       route: "/leads-dashboard",
//       //     },
//       //   ],
//       // },
//       // {
//       //   menuValue: 'Apps',
//       //   hasSubRoute: true,
//       //   showSubRoute: false,
//       //   route: "#",
//       //   icon: "la la-cube",
//       //   subMenus: [
//       //     {
//       //       menuValue: 'Chats',
//       //       route: "/chat",
//       //     },
//       //     {
//       //       menuValue: 'Calls',
//       //       route: "#",
//       //       showMenuRoute: true,
//       //       subMenusValues: [
//       //           {
//       //               menuValue: 'Voice Call',
//       //               route: "/voice-call",
//       //             },
//       //           {
//       //               menuValue: 'Video Call',
//       //               route: "/video-call",
//       //             },
//       //           {
//       //               menuValue: 'Outgoing Call',
//       //               route: "/outgoing-call",
//       //             },
//       //           {
//       //               menuValue: 'Incoming Call',
//       //               route: "/incoming-call",
//       //             },
//       //       ]
//       //     },
//       //     {
//       //       menuValue: 'Calendar',
//       //       route: "/events",
//       //     },
//       //     {
//       //       menuValue: 'Contacts',
//       //       route: "/contacts",
//       //     },
//       //     {
//       //       menuValue: 'Email',
//       //       route: "/inbox",
//       //     },
//       //     {
//       //       menuValue: 'File Manager',
//       //       route: "/file-manager",
//       //     },
//       //   ],
//       // },      
//     ],

//   },
//   // {
//   //   tittle: 'EMPLOYEES',
//   //   showAsTab: false,
//   //   separateRoute: false,
//   //   menu: [
//   //     {
//   //       menuValue: 'Employees',
//   //       hasSubRoute: true,
//   //       showSubRoute: false,
//   //       route: "#",
//   //       icon: "la la-user",
//   //       subMenus: [
//   //         {
//   //           menuValue: 'All Employees',
//   //           route: "/employees",
//   //         },
//   //         {
//   //           menuValue: 'Holidays',
//   //           route: "/holidays",
//   //         },
//   //         {
//   //           menuValue: 'Leaves(Admin)',
//   //           route: "/adminleaves",
//   //         },
//   //         {
//   //           menuValue: 'Leaves(Employee)',
//   //           route: "/leaves-employee",
//   //         },
//   //         {
//   //           menuValue: 'Leave Settings',
//   //           route: "/leave-settings",
//   //         },
//   //         {
//   //           menuValue: 'Attendance (Admin)',
//   //           route: "/adminattendance",
//   //         },
//   //         {
//   //           menuValue: 'Attendance (Employee)',
//   //           route: "/attendance-employee",
//   //         },
//   //         {
//   //           menuValue: 'Departments',
//   //           route: "/departments",
//   //         },
//   //         {
//   //           menuValue: 'Designations',
//   //           route: "/designations",
//   //         },
//   //         {
//   //           menuValue: 'Timesheet',
//   //           route: "/timesheet",
//   //         },
//   //         {
//   //           menuValue: 'Shift & Schedule',
//   //           route: "/shift-scheduling",
//   //         },
//   //         {
//   //           menuValue: 'Overtime',
//   //           route: "/overtime",
//   //         },
//   //       ],
//   //     },
//   //     // {
//   //     //   menuValue: 'Clients',
//   //     //   hasSubRoute: false,
//   //     //   showSubRoute: false,
//   //     //   route: "/clients",
//   //     //   icon: "la la-users",
//   //     // },

    
//   //     // {
//   //     //   menuValue: 'Projects',
//   //     //   hasSubRoute: true,
//   //     //   showSubRoute: false,
//   //     //   icon: "la la-rocket",
//   //     //   subMenus: [
//   //     //     {
//   //     //       menuValue: 'Projects',
//   //     //       route: "/projects",
//   //     //     },
//   //     //     {
//   //     //       menuValue: 'Tasks',
//   //     //       route: "/tasks",
//   //     //     },
//   //     //     {
//   //     //       menuValue: 'Tasks Board',
//   //     //       route: "/task-board",
//   //     //     },
//   //     //   ],
//   //     // },
//   //     // {
//   //     //   menuValue: 'Tickets',
//   //     //   hasSubRoute: true,
//   //     //   showSubRoute: false,
//   //     //   icon: "la la-ticket",
//   //     //   subMenus: [
//   //     //     {
//   //     //       menuValue: 'Tickets',
//   //     //       route: "/tickets",
//   //     //     },
//   //     //     {
//   //     //       menuValue: 'Ticket Details',
//   //     //       route: "/ticket-details",
//   //     //     },
        
//   //     //   ],
//   //     // },
//   //   ],
//   // },
//   // {
//   //   tittle: 'CRM',
//   //   showAsTab: false,
//   //   separateRoute: false,
//   //   menu: [
   
//   //     {
//   //       menuValue: 'Companies',
//   //       hasSubRoute: false,
//   //       showSubRoute: false,
//   //       route: "/companies",
//   //       icon: "la la-building",
//   //     },
//   //     {
//   //       menuValue: 'Deals',
//   //       hasSubRoute: false,
//   //       showSubRoute: false,
//   //       route: "/deals",
//   //       icon: "la la-cubes",
//   //     },
//   //     {
//   //       menuValue: 'Leads',
//   //       hasSubRoute: false,
//   //       showSubRoute: false,
//   //       route: "/leads-list",
//   //       icon: "la la-chart-area",
//   //     },
//   //     {
//   //       menuValue: 'Pipeline',
//   //       hasSubRoute: false,
//   //       showSubRoute: false,
//   //       route: "/pipeline",
//   //       icon: "la la-exchange-alt",
//   //     },
//   //     {
//   //       menuValue: 'Analytics',
//   //       hasSubRoute: false,
//   //       showSubRoute: false,
//   //       route: "/analytics",
//   //       icon: "la la-dice",
//   //     },
//   //     {
//   //       menuValue: 'Activities',
//   //       hasSubRoute: false,
//   //       showSubRoute: false,
//   //       route: "/activities",
//   //       icon: "la la-directions",
//   //     },
//   //   ],
//   // },
//   {
//     tittle: 'HR',
//     showAsTab: false,
//     separateRoute: false,
//     menu: [
    
    
//       {
//         menuValue: 'Expenses',
//         hasSubRoute: false,
//         showSubRoute: false,
//         icon: "la la-wallet",
//         route: "/expenses",
//         // subMenus: [
//         //   {
//         //     menuValue: 'Estimates',
//         //     route: "/estimates",
//         //   },
//         //   {
//         //     menuValue: 'Invoices',
//         //     route: "/invoices",
//         //   },
//         //   {
//         //     menuValue: 'Payments',
//         //     route: "/payments",
//         //   },
//         //   {
//         //     menuValue: 'Expenses',
//         //     route: "/expenses",
//         //   },
//         //   {
//         //     menuValue: 'Provident Fund',
//         //     route: "/provident-fund",
//         //   },
//         //   {
//         //     menuValue: 'Taxes',
//         //     route: "/taxes",
//         //   },
//         // ],
//       },
//       {
//         menuValue: 'Payroll',
//         hasSubRoute: true,
//         showSubRoute: false,
//         icon: "la la-money",
//         subMenus: [
//           {
//             menuValue: 'Employee Salary',
//             route: "/salary",
//           },
//           // {
//           //   menuValue: 'Payslip',
//           //   route: "/salary-view",
//           // },
//           {
//             menuValue: 'Payroll Items',
//             route: "/salary/payroll",
//           },
//         ]
//       },

//     {
//       menuValue: 'Documents',
//       hasSubRoute: false,
//       showSubRoute: false,
//       icon: "la la-file-pdf-o",
//       route: "/documents",
//     },

//       // {
//       //   menuValue: 'Accounting',
//       //   hasSubRoute: true,
//       //   showSubRoute: false,
//       //   icon: "la la-files-o",
//       //   subMenus: [
//       //     {
//       //       menuValue: 'Categories',
//       //       route: "/categories",
//       //     },
//       //     {
//       //       menuValue: 'Budgets',
//       //       route: "/budgets",
//       //     },
//       //     {
//       //       menuValue: 'Budget Revenues',
//       //       route: "/budget-revenues",
//       //     },
//       //     {
//       //       menuValue: 'Budget Expenses',
//       //       route: "/budget-expenses",
//       //     },
         
//       //   ],
//       // },

//       // {
//       //   menuValue: 'Payroll',
//       //   hasSubRoute: true,
//       //   showSubRoute: false,
//       //   icon: "la la-money",
//       //   subMenus: [
//       //     {
//       //       menuValue: 'Employee Salary',
//       //       route: "/salary",
//       //     },
//       //     {
//       //       menuValue: 'Payslip',
//       //       route: "/salary-view",
//       //     },
//       //     {
//       //       menuValue: 'Payroll Items',
//       //       route: "/payroll-items",
//       //     },
         
         
//       //   ],
//       // },
//       // {
//       //   menuValue: 'Policies',
//       //   hasSubRoute: false,
//       //   showSubRoute: false,
//       //   route: "/policies",
//       //   icon: "la la-file-pdf-o",
//       // },
// //       {
// //         menuValue: "Reports",
// //         hasSubRoute: true,
// //         showSubRoute: false,
// //         icon: "la la-chart-pie",
// //         subMenus: [
// //           {
// //             menuValue: "Attendance Report",
// //             route: "/attendance-reports"
// //           },
// //           {
// //             menuValue: "Leave Report",
// //             route: "/leave-reports"
// //           },
// //           {
// //             menuValue: "Payslip Report",
// //             route: "/payslip-reports"
// //           },
          
// //           {
// //             menuValue: "Performance Report",
// //             route: "/employee-reports"
// //           },
// //           {
// //             menuValue: "Training & Development Report",
// //             route: "/task-reports"
// //           },
// //           {
// //             menuValue: "Expense Report",
// //             route: "/expense-reports"
// //           },


// //           {
// //             menuValue: 'Timesheet Report',
// //             route: "/timesheet",
// //           },
// //           {
// //             menuValue: "Employee Demographics Report",
// //             route: "/user-reports"
// //           },
// //           {
// //             menuValue: "Attrition/Turnover Report",
// //             route: "/payments-reports"
// //           },

// //           {
// //             menuValue: "Recruitment Report",
// //             route: "/user-reports"
// //           },
// //           {
// //             menuValue: "Recruitment Report",
// //             route: "/user-reports"
// //           },

// //  {
// //             menuValue: "Employee Satisfaction Report",
// //             route: "/user-reports"
// //           },
          
// //           {
// //             menuValue: "Performance Report",
// //             route: "/performance-indicator"
// //           },
// //           {
// //             menuValue: "Workforce Headcount Report",
// //             route: "/task-reports"
// //           },

// //           {
// //             menuValue: "Expense & Reimbursement Report",
// //             route: "/expense-reports"
// //           },


// //           // {
// //           //   menuValue: "Invoice Report",
// //           //   route: "/invoice-reports"
// //           // },
// //           // {
// //           //   menuValue: "Payments Report",
// //           //   route: "/payments-reports"
// //           // },
// //           // {
// //           //   menuValue: "Project Report",
// //           //   route: "/project-reports"
// //           // },
// //           // {
// //           //   menuValue: "Task Report",
// //           //   route: "/task-reports"
// //           // },
// //           // {
// //           //   menuValue: "User Report",
// //           //   route: "/user-reports"
// //           // },
          
         
          
// //           {
// //             menuValue: "Daily Report",
// //             route: "/daily-reports"
// //           }
// //         ]
// //       }
//     ],
//   },
//   // {
//   //   tittle: 'PERFORMANCE',
//   //   showAsTab: false,
//   //   separateRoute: false,
//   //   menu: [
//   //       {
//   //           menuValue: "Performance",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-graduation-cap",
//   //           subMenus: [
//   //             {
//   //               menuValue: "Performance Indicator",
//   //               route: "/performance-indicator"
//   //             },
//   //             {
//   //               menuValue: "Performance Review",
//   //               route: "/performance"
//   //             },
//   //             {
//   //               menuValue: "Performance Appraisal",
//   //               route: "/performance-appraisal"
//   //             }
//   //           ]
//   //         },

//   //         {
//   //           menuValue: "Goals",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-crosshairs",
//   //           subMenus: [
//   //             {
//   //               menuValue: "Goal List",
//   //               route: "/goal-tracking"
//   //             },
//   //             {
//   //               menuValue: "Goal Type",
//   //               route: "/goal-type"
//   //             }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: "Training",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-edit",
//   //           subMenus: [
//   //             {
//   //               menuValue: "Training List",
//   //               route: "/training"
//   //             },
//   //             {
//   //               menuValue: "Trainers",
//   //               route: "/trainers"
//   //             },
//   //             {
//   //               menuValue: "Training Type",
//   //               route: "/training-type"
//   //             }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: 'Promotion',
//   //           hasSubRoute: false,
//   //           showSubRoute: false,
//   //           route: "/promotion",
//   //           icon: "la la-bullhorn",
//   //         },
//   //         {
//   //           menuValue: 'Resignation',
//   //           hasSubRoute: false,
//   //           showSubRoute: false,
//   //           route: "/resignation",
//   //           icon: "la la-external-link-square",
//   //         },
//   //         {
//   //           menuValue: 'Termination',
//   //           hasSubRoute: false,
//   //           showSubRoute: false,
//   //           route: "/termination",
//   //           icon: "la la-times-circle",
//   //         },

          
//   //   ],
//   // },

//   {
//     tittle: 'ADMINISTRATION',
//     showAsTab: false,
//     separateRoute: false,
//     menu: [
//         {
//             menuValue: 'Assets',
//             hasSubRoute: false,
//             showSubRoute: false,
//             route: "/assets",
//             icon: "la la-boxes",
//           },
//           {
//             menuValue: 'Jobs',
//             hasSubRoute: true,
//             showSubRoute: false,
//             // route: "/manage-jobs",
//             icon: "la la-briefcase",
//             subMenus: [
//               {
//                 menuValue: 'Manage Jobs',
//                 route: "/manage-jobs",
//               },
//               {
//                 menuValue: 'Manage Resumes',
//                 route: "/manage-resumes",
//               },
//             ]
//           },
//           {
//             menuValue: 'Uniform Management',
//             hasSubRoute: true,
//             showSubRoute: false,
//             // route: "/uniforms",
//             icon: "la la-shirtsinbulk",
//             subMenus: [
//               {
//                 menuValue: 'Uniforms',
//                 route: "/uniforms",
//               },
//               {
//                 menuValue: 'Assign Uniform',
//                 route: "/uniforms/assign-uniform",
//               },
//               {
//                 menuValue: 'List Allocations',
//                 route: "/uniforms/uniform-allocations",
//               },
//             ]
//           },
//           {
//             menuValue: 'Others',
//             hasSubRoute: true,
//             showSubRoute: false,
//             icon: "la la-archive",
//             subMenus: [
//               {
//                 menuValue: 'Designations',
//                 route: "/designations",
//               },
//               {
//                 menuValue: 'Departments',
//                 route: "/departments",
//               },
//               {
//                 menuValue: 'Grades',
//                 route: "/grades",
//               },
//               {
//                 menuValue: 'Roles & Permissions',
//                 route: "/roles-permissions",
//               },

              
//               //      {
//               //   menuValue: "Manage Resumes",
//               //   route: "/manage-resumes"
//               // },
//               // {
//               //   menuValue: "Shortlist Candidates",
//               //   route: "/shortlist-candidates"
//               // },
//               // {
//               //   menuValue: "Interview Questions",
//               //   route: "/interview-questions"
//               // },
//               // {
//               //   menuValue: "Offer Approvals",
//               //   route: "/offer_approvals"
//               // },
//               // {
//               //   menuValue: "Experience Level",
//               //   route: "/experiance-level"
//               // },
//               // {
//               //   menuValue: "Candidates List",
//               //   route: "/candidates"
//               // },
//               //        {
//               //   menuValue: "User Dasboard",
//               //   route: "/user-dashboard"
//               // },
//               // {
//               //   menuValue: "Jobs Dasboard",
//               //   route: "/jobs-dashboard"
//               // },
//             ]
//           },
//           // {
//           //   menuValue: "Jobs",
//           //   hasSubRoute: true,
//           //   showSubRoute: false,
//           //   icon: "la la-briefcase",
//           //   subMenus: [
//           //     // {
//           //     //   menuValue: "User Dasboard",
//           //     //   route: "/user-dashboard"
//           //     // },
//           //     // {
//           //     //   menuValue: "Jobs Dasboard",
//           //     //   route: "/jobs-dashboard"
//           //     // },
//           //     {
//           //       menuValue: "Manage Jobs",
//           //       route: "/jobs"
//           //     },
//           //     // {
//           //     //   menuValue: "Manage Resumes",
//           //     //   route: "/manage-resumes"
//           //     // },
//           //     // {
//           //     //   menuValue: "Shortlist Candidates",
//           //     //   route: "/shortlist-candidates"
//           //     // },
//           //     // {
//           //     //   menuValue: "Interview Questions",
//           //     //   route: "/interview-questions"
//           //     // },
//           //     // {
//           //     //   menuValue: "Offer Approvals",
//           //     //   route: "/offer_approvals"
//           //     // },
//           //     // {
//           //     //   menuValue: "Experience Level",
//           //     //   route: "/experiance-level"
//           //     // },
//           //     // {
//           //     //   menuValue: "Candidates List",
//           //     //   route: "/candidates"
//           //     // },
//           //     // {
//           //     //   menuValue: "Schedule timing",
//           //     //   route: "/schedule-timing"
//           //     // },
//           //     // {
//           //     //   menuValue: "Aptitude Results",
//           //     //   route: "/apptitude-result"
//           //     // }
//           //   ]
//           // },
//           // {
//           //   menuValue: 'Knowledgebase',
//           //   hasSubRoute: false,
//           //   showSubRoute: false,
//           //   route: "/knowledgebase",
//           //   icon: "la la-question",
//           // },
//           // {
//           //   menuValue: 'Users',
//           //   hasSubRoute: false,
//           //   showSubRoute: false,
//           //   route: "/users",
//           //   icon: "la la-user-plus",
//           // },
//           // {
//           //   menuValue: 'Settings',
//           //   hasSubRoute: false,
//           //   showSubRoute: false,
//           //   route: "/company-settings",
//           //   icon: "la la-cog",
//           // },
      
//     ],
//   },
//   // {
//   //   tittle: 'PAGES',
//   //   showAsTab: false,
//   //   separateRoute: false,
//   //   menu: [
//   //       {
//   //           menuValue: "Profile",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-user-tag",
//   //           subMenus: [
//   //             {
//   //               menuValue: "Employee Profile",
//   //               route: "/profile"
//   //             },
//   //             {
//   //               menuValue: "Client Profile",
//   //               route: "/client-profile"
//   //             }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: "Authentication",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-key",
//   //           subMenus: [
//   //             {
//   //               menuValue: "Login",
//   //               route: "/"
//   //             },
//   //             {
//   //               menuValue: "Register",
//   //               route: "/register"
//   //             },
//   //             {
//   //               menuValue: "Forgot Password",
//   //               route: "/forgot-password"
//   //             },
//   //             {
//   //               menuValue: "OTP",
//   //               route: "/otp"
//   //             },
//   //             {
//   //               menuValue: "Lock Screen",
//   //               route: "/lock-screen"
//   //             }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: "Error Pages",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-exclamation-triangle",
//   //           subMenus: [
//   //             {
//   //               menuValue: "404 Error",
//   //               route: "/error-404"
//   //             },
//   //             {
//   //               menuValue: "500 Error",
//   //               route: "/error-500"
//   //             }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: "Subscriptions",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-history",
//   //           subMenus: [
//   //             {
//   //               menuValue: "Subscriptions (Admin)",
//   //               route: "/subscriptions"
//   //             },
//   //             {
//   //               menuValue: "Subscriptions (Company)",
//   //               route: "/subscriptions-company"
//   //             },
//   //             {
//   //               menuValue: "Subscribed Companies",
//   //               route: "/subscribed-companies"
//   //             }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: "Pages",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-columns",
//   //           subMenus: [
//   //             {
//   //               menuValue: "Search",
//   //               route: "/search"
//   //             },
//   //             {
//   //               menuValue: "FAQ",
//   //               route: "/faq"
//   //             },
//   //             {
//   //               menuValue: "Terms",
//   //               route: "/terms"
//   //             },
//   //             {
//   //               menuValue: "Privacy Policy",
//   //               route: "/privacy-policy"
//   //             },
//   //             {
//   //               menuValue: "Blank Page",
//   //               route: "/blank-page"
//   //             },
//   //             {
//   //               menuValue: "Coming Soon",
//   //               route: "/coming-soon"
//   //             },
//   //             {
//   //               menuValue: "Under Maintenance",
//   //               route: "/under-maintenance"
//   //             }
//   //           ]
//   //         }
          
//   //   ],
//   // },
 
 
  
 
//   // {
//   //   tittle: 'UI INTERFACE',
//   //   showAsTab: false,
//   //   separateRoute: false,
//   //   menu: [
//   //       {
//   //           menuValue: "Base UI",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "lab la-uikit",
//   //           subMenus: [
//   //             { menuValue: "Alerts", route: "/alerts" },
//   //             { menuValue: "Accordion", route: "/accordion" },
//   //             { menuValue: "Avatar", route: "/avatar" },
//   //             { menuValue: "Badges", route: "/badges" },
//   //             { menuValue: "Border", route: "/borders" },
//   //             { menuValue: "Buttons", route: "/buttons" },
//   //             { menuValue: "Button Group", route: "/buttongroup" },
//   //             { menuValue: "Breadcrumb", route: "/breadcrumb" },
//   //             { menuValue: "Card", route: "/cards" },
//   //             { menuValue: "Carousel", route: "/carousel" },
//   //             { menuValue: "Colors", route: "/colors" },
//   //             { menuValue: "Dropdowns", route: "/dropdowns" },
//   //             { menuValue: "Grid", route: "/grid" },
//   //             { menuValue: "Images", route: "/images" },
//   //             { menuValue: "Lightbox", route: "/lightbox" },
//   //             { menuValue: "Media", route: "/media" },
//   //             { menuValue: "Modals", route: "/modals" },
//   //             { menuValue: "Notification", route: "/notification" },
//   //             { menuValue: "Offcanvas", route: "/offcanvas" },
//   //             { menuValue: "Pagination", route: "/pagination" },
//   //             { menuValue: "Popovers", route: "/popover" },
//   //             { menuValue: "Progress", route: "/progress" },
//   //             { menuValue: "Placeholders", route: "/placeholders" },
//   //             { menuValue: "Range Slider", route: "/rangeslider" },
//   //             { menuValue: "Spinner", route: "/spinner" },
//   //             { menuValue: "Sweet Alerts", route: "/sweetalert" },
//   //             { menuValue: "Tabs", route: "/nav-tabs" },
//   //             { menuValue: "Toasts", route: "/toastr" },
//   //             { menuValue: "Tooltips", route: "/tooltips" },
//   //             { menuValue: "Typography", route: "/typography" },
//   //             { menuValue: "Video", route: "/video" }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: "Advanced UI",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-eject",
//   //           subMenus: [
//   //             { menuValue: "Ribbon", route: "/ribbon" },
//   //             { menuValue: "Clipboard", route: "/clipboard" },
//   //             { menuValue: "Drag & Drop", route: "/dragdrop" },
//   //             { menuValue: "Range Slider", route: "/rangeslider" },
//   //             { menuValue: "Rating", route: "/rating" },
//   //             { menuValue: "Text Editor", route: "/text-editor" },
//   //             { menuValue: "Counter", route: "/counter" },
//   //             { menuValue: "Scrollbar", route: "/scrollbar" },
//   //             { menuValue: "Sticky Note", route: "/stickynote" },
//   //             { menuValue: "Timeline", route: "/timeline" }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: "Charts",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-chart-line",
//   //           subMenus: [
//   //             { menuValue: "Apex Charts", route: "/apex-charts" },
//   //             { menuValue: "Chart Js", route: "/chartjs" },
//   //             { menuValue: "Morris Charts", route: "/morris-charts" },
//   //             { menuValue: "Flot Charts", route: "/flot-charts" },
//   //             { menuValue: "Peity Charts", route: "/peity-charts" },
//   //             { menuValue: "C3 Charts", route: "/charts-c3" }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: "Icons",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-icons",
//   //           subMenus: [
//   //             { menuValue: "Fontawesome Icons", route: "/fontawesome-icons" },
//   //             { menuValue: "Feather Icons", route: "/feather-icons" },
//   //             { menuValue: "Ionic Icons", route: "/ionic-icons" },
//   //             { menuValue: "Material Icons", route: "/material-icons" },
//   //             { menuValue: "Pe7 Icons", route: "/pe7-icons" },
//   //             { menuValue: "Simpleline Icons", route: "/simpleline-icons" },
//   //             { menuValue: "Themify Icons", route: "/themify-icons" },
//   //             { menuValue: "Weather Icons", route: "/weather-icons" },
//   //             { menuValue: "Typicon Icons", route: "/typicons" },
//   //             { menuValue: "Flag Icons", route: "/flag-icons" }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: "Forms",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-wpforms",
//   //           subMenus: [
//   //             { menuValue: "Basic Inputs", route: "/form-basic-inputs" },
//   //             { menuValue: "Input Groups", route: "/form-input-groups" },
//   //             { menuValue: "Horizontal Form", route: "/form-horizontal" },
//   //             { menuValue: "Vertical Form", route: "/form-vertical" },
//   //             { menuValue: "Form Mask", route: "/form-mask" },
//   //             { menuValue: "Form Validation", route: "/form-validation" },
//   //             { menuValue: "Form Select2", route: "/form-select2" },
//   //             { menuValue: "File Upload", route: "/file-upload" },
//   //             { menuValue: "Horizontal Timeline", route: "/horizontal-timeline" },
//   //             { menuValue: "Form Wizard", route: "/form-wizard" }
//   //           ]
//   //         },
//   //         {
//   //           menuValue: "Tables",
//   //           hasSubRoute: true,
//   //           showSubRoute: false,
//   //           icon: "la la-table",
//   //           subMenus: [
//   //             { menuValue: "Basic Tables", route: "/tables-basic" },
//   //             { menuValue: "Data Table", route: "/data-tables" }
//   //           ]
//   //         }
          
//   //   ],
//   // },
//   // {
//   //   tittle: 'EXTRAS',
//   //   showAsTab: false,
//   //   separateRoute: false,
//   //   menu: [
//   //     {
//   //       menuValue: 'Documentation',
//   //       hasSubRoute: false,
//   //       showSubRoute: false,       
//   //       route: "#",
//   //       icon: "la la-file-text",
//   //     },

//   //     {
//   //       menuValue: 'Change Log',
//   //       hasSubRoute: false,
//   //       showSubRoute: false,
//   //       route: "#",
//   //       icon: "la la-info",
//   //     },

//   //     {
//   //       menuValue: "Multi Level",
//   //       hasSubRoute: true,
//   //       showSubRoute: false,
//   //       icon: "la la-share-alt",
//   //       subMenus: [
//   //         { menuValue: "Level 1", route: "#" },
         
//   //       ]
//   //     },
     
    
//   //   ],
//   // },
// ];




export const SidebarData = [
  {
    menuValue: 'Dashboard',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/employee-dashboard",
    icon: "la la-dashcube",
    code: "dashboard"
  },
  {
    menuValue: 'Employee Statistics',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/employee-statistics",
    icon: "la la-chart-bar",
    code: "employee_statistics"
  },
  {
    menuValue: 'Employees',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/employees",
    icon: "la la-user",
    code: "employee"
  },
  {
    menuValue: 'Holidays',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/holidays",
    icon: "la la-calendar-o",
    code: "holiday"
  },
  {
    menuValue: 'Leaves',
    hasSubRoute: true,
    showSubRoute: false,
    // route: "/leaves-employee",
    icon: "la la-calendar-check-o",
    code: "leave",
    subMenus: [
      {
        menuValue: 'Leave List',
        route: "/leaves-employee",
        code: "leave",

      },
      {
        menuValue: 'Leave View',
        route: "/leave-calendar",
        code: "leave",

      },
      {
        menuValue: 'Leave Planner',
        route: "/leave-planner",
        code: "leave",

      },
    ]
  },
  {
    menuValue: 'Company Directory',
    hasSubRoute: false,
    showSubRoute: false,
    route: "/company-directory",
    icon: "la la-user-shield",
    code: "company_directory",
  },
  {
    menuValue: 'Expenses',
    hasSubRoute: false,
    showSubRoute: false,
    icon: "la la-wallet",
    route: "/expenses",
    code: "expense",
  
  },
  {
    menuValue: 'Payroll',
    hasSubRoute: true,
    showSubRoute: false,
    icon: "la la-money",
    code: "payroll",
    subMenus: [
      {
        menuValue: 'Employee Salary',
        route: "/salary",
        code: "payroll",

      },
    
      {
        menuValue: 'Payroll Items',
        route: "/salary/payroll",
        code: "payroll",

      },
    ]
  },

{
  menuValue: 'Documents',
  hasSubRoute: true,
  showSubRoute: false,
  icon: "la la-file-pdf-o",
  // route: "/documents",
  code: "document",
  subMenus: [
    {
      menuValue: 'User Documents',
      route: "/documents",
        code: "document_employee",

    },
  
    {
      menuValue: 'Store Documents',
      route: "/documents/store",
      code: "document_store",

    },
  ]
},
{
  menuValue: 'Assets',
  hasSubRoute: false,
  showSubRoute: false,
  route: "/assets",
  icon: "la la-boxes",
  code: "asset",
},
{
  menuValue: 'Jobs',
  hasSubRoute: true,
  showSubRoute: false,
  // route: "/manage-jobs",
  code: "job",
  icon: "la la-briefcase",
  subMenus: [
    {
      menuValue: 'Manage Jobs',
      route: "/manage-jobs",
      code: "job_hiring",

    },
    {
      menuValue: 'Manage Resumes',
      route: "/manage-resumes",
      code: "job_hiring",

    },
    {
      menuValue: 'Employee referrals',
      route: "/employee-referrals",
      code: "job_referral",

    },
  ]
},
{
  menuValue: 'Uniform Management',
  hasSubRoute: true,
  showSubRoute: false,
  code: "uniform_management",
  // route: "/uniforms",
  icon: "la la-shirtsinbulk",
  subMenus: [
    {
      menuValue: 'Uniforms',
      route: "/uniforms",
      code: "uniform",

    },
    {
      menuValue: 'Assign Uniform',
      route: "/uniforms/assign-uniform",
      code: "uniform_assign",

    },
    {
      menuValue: 'List Allocations',
      route: "/uniforms/uniform-allocations",
      code: "uniform_user",

    },
    {
      menuValue: 'Uniform Stock',
      route: "/uniforms/uniform-stock",
      code: "uniform_stock",

    },
  ]
},

{
  menuValue: 'Resignation',
  hasSubRoute: false,
  showSubRoute: false,
  route: "/resignations",
  icon: "las la-user-times",
  code: "resignation",
},


{
  menuValue: 'Discount',
  hasSubRoute: false,
  showSubRoute: false,
  route: "https://discount.nandosess.ae",
  icon: "las la-percentage",
  code: "staff_discount",
},

{
  menuValue: 'Others',
  hasSubRoute: true,
  showSubRoute: false,
  icon: "la la-archive",
  code: "others",

  subMenus: [
    {
      menuValue: 'Designations',
      route: "/designations",
      code: "designation",

    },
    {
      menuValue: 'Departments',
      route: "/departments",
      code: "department",
    },
    {
      menuValue: 'Grades',
      route: "/grades",
      code: "grades",

    },

   
  ]
},

          {
            menuValue: 'Settings',
            hasSubRoute: true,
            showSubRoute: false,
            route: "/settings",
            icon: "la la-cog",
            code: "role_permission",
            subMenus: [
             
              {
                menuValue: 'Roles & Permissions',
                route: "/roles-permissions",
                code: "role_permission",
              },

              {
                menuValue: 'Request Approver',
                route: "/request-approver",
                code: "role_permission",
              },
              {
                menuValue: 'Sync Data',
                route: "/sync-data",
                code: "data_sync",
              },
             
            ]
          },


   
  ];
  